import { render, staticRenderFns } from "./AudioWave.vue?vue&type=template&id=d40c2088&scoped=true&"
import script from "./AudioWave.vue?vue&type=script&lang=js&"
export * from "./AudioWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40c2088",
  null
  
)

export default component.exports